import { createThunk, ExtendedModel, model } from 'mst-collection';
import { castToSnapshot, getParent, getRoot } from 'mobx-state-tree';

import { Api } from '@api';
import { handleFlow, shouldRejectPagination } from '../utils';
import { PostList } from './PostListModel';
import type { User } from '../Viewer/UserModel';
import type { RootModelType } from '../RootModel';

export class UserPostList extends ExtendedModel(PostList, {}) {
  private get _parentUserId() {
    return getParent<User>(this).id;
  }

  fetch = createThunk(() => {
    return async function fetch(this: UserPostList) {
      const res = await Api.Feed.getUserPosts({
        id: this._parentUserId,
        count: this.pageSize,
        start: 0,
      });

      const posts = await getRoot<RootModelType>(
        this,
      ).posts.fetchUsersAndMerge.run(res.data.items);

      this.set(posts);
    };
  });

  fetchMore = createThunk(() => {
    return async function fetchMore(this: UserPostList, flow) {
      if (shouldRejectPagination(this)) {
        return;
      }

      await handleFlow(flow, async () => {
        const res = await Api.Feed.getUserPosts({
          id: this._parentUserId,
          count: this.pageSize,
          start: this.offset,
        });

        const posts = await getRoot<RootModelType>(
          this,
        ).posts.fetchUsersAndMerge.run(res.data.items);

        this.append(castToSnapshot(posts));
      });
    };
  }, false);
}

export const UserPostListModel = model(UserPostList);
